import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';

const list = (systemSource, merchantId, branchId, filters, page, pageSize) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/reservations`),
		{
			branchId,
			pageNum: page,
			pageSize,
			...filters,
		}
	);
};

const diagram = (systemSource, merchantId, branchId, filters) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservations-diagram`
		),
		{
			branchId,
			...filters,
		}
	);
};

const exportReport = (systemSource, merchantId, branchId, filters) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservations/report/export`
		),
		{
			branchId,
			...filters,
		},
		{
			responseType: 'blob',
		}
	);
};

const listArea = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/areas`),
		{
			branchId,
		}
	);
};

const listTableSet = (systemSource, merchantId, branchId, areaId) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableSets/picture`),
		{
			branchId,
			areaId,
		}
	);
};

const listTableSetPage = (systemSource, merchantId, branchId, conditions) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableSets`),
		{
			branchId,
			...conditions,
		}
	);
};

const updateTableSet = (systemSource, merchantId, id, data) => {
	return Client.put(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableSets/${id}`),
		data
	);
};

const deleteTableSet = (systemSource, merchantId, id, payload) => {
	return Client.del(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableSets/${id}`),
		payload
	);
};

const checkComination = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/tableSets/combinationCheck`
		),
		payload
	);
};

const createCombination = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/tableSets/combinationTables`
		),
		payload
	);
};

const settings = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings`
		),
		{
			branchId,
		}
	);
};

const createSettings = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings`
		),
		payload
	);
};

const updateSettings = (systemSource, merchantId, id, payload) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings/${id}`
		),
		payload
	);
};

const mealTimeSettings = (systemSource, merchantId, branchId, weekDay) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/mealTimeSettings`),
		{
			branchId,
			weekDay,
		}
	);
};

const validMealTime = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/valid-meal-time`),
		data
	);
};

const createMealTime = (
	systemSource,
	merchantId,
	branchId,
	weekDay,
	kind,
	priorityType,
	start,
	end,
	limitPersons,
	available,
	operateBy
) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/mealTimeSettings`),
		{
			branchId,
			weekDay,
			start,
			end,
			kind,
			limitPersons,
			priorityType,
			available,
			operateBy,
		}
	);
};

const updateMealTime = (
	systemSource,
	merchantId,
	branchId,
	id,
	weekDay,
	kind,
	priorityType,
	start,
	end,
	limitPersons,
	available,
	operateBy
) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/mealTimeSettings/${id}`
		),
		{
			branchId,
			weekDay,
			start,
			end,
			kind,
			limitPersons,
			priorityType,
			available,
			operateBy,
		}
	);
};

const removeMealTime = (systemSource, merchantId, branchId, id, operateBy) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/mealTimeSettings/${id}`
		),
		{
			branchId,
			operateBy,
		}
	);
};

const closedDaySettings = (systemSource, merchantId, branchId, busType) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tempBusTimes`),
		{
			branchId,
			busType,
		}
	);
};

const createClosedDay = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tempBusTimes`),
		data
	);
};

const updateClosedDay = (systemSource, merchantId, id, data) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/tempBusTimes/${id}`
		),
		data
	);
};

const removeClosedDay = (systemSource, merchantId, branchId, id, operateBy) => {
	return Client.del(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/tempBusTimes/${id}`
		),
		{
			branchId,
			operateBy,
		}
	);
};

const kpiSummary = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservations/kpi-summary`
		),
		data
	);
};

const batchModifyTablesets = (systemSource, merchantId, data) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/tableSets/batch-modify`
		),
		data
	);
};

const guestReservation = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/guests/reservations`
		),
		data
	);
};

export default {
	list,
	diagram,
	exportReport,
	listTableSet,
	listArea,
	listTableSetPage,
	updateTableSet,
	deleteTableSet,
	checkComination,
	createCombination,
	settings,
	createSettings,
	updateSettings,
	mealTimeSettings,
	validMealTime,
	createMealTime,
	updateMealTime,
	removeMealTime,
	closedDaySettings,
	createClosedDay,
	updateClosedDay,
	removeClosedDay,
	kpiSummary,
	batchModifyTablesets,
	guestReservation,
};
